import { isMobile, isTablet, osName } from 'react-device-detect';
import { DEVICE_TYPE_DESKTOP, DEVICE_TYPE_MOBILE, DEVICE_TYPE_TABLET, SCREEN_ORIENTATION_LANDSCAPE, SCREEN_ORIENTATION_PORTRAIT } from '../../../hooks/useTracking/utils/types.js';
export const getDeviceType = () => {
  if (isTablet) {
    return DEVICE_TYPE_TABLET;
  }
  if (isMobile) {
    return DEVICE_TYPE_MOBILE;
  }
  // There are other device types too (smartv, wearable, ...).
  // Our tracking spec however only expects three.
  // So at this point we bunch the rest together as "desktop".
  return DEVICE_TYPE_DESKTOP;
};
export const getOperatingSystem = () => osName;
export const getScreenOrientation = () => {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return SCREEN_ORIENTATION_PORTRAIT;
  }
  if (window.matchMedia('(orientation: landscape)').matches) {
    return SCREEN_ORIENTATION_LANDSCAPE;
  }
  // we should never get here
};
export const buildVirtualPath = (page, portal) => {
  const portalDesignators = {
    'aidu-de': 'AiduDe',
    'aidu-at': 'AiduAt',
    'aidu-ch': 'AiduCh',
    'invia-cz': 'InviaCz',
    'invia-hu': 'InviaHu',
    'invia-sk': 'InviaSk',
    'travelplanet-pl': 'TravelPlanetPl',
    'reisegeier-at': 'ReisegeierAt',
    'reisegeier-ch': 'ReisegeierCh',
    'reisegeier-de': 'ReisegeierDe',
    'reisen-de': 'ReisenDe',
    'reisen-fluege-de': 'ReisenFluegeDe',
    'travelchannel-de': 'TravelChannelDe'
  };
  return `${portal ? portalDesignators[portal] : 'unknown'}/Bali${page}`;
};